import React from "react";
import { FiInstagram, FiPhone, FiMapPin } from "react-icons/fi";
import { SiWhatsapp } from "react-icons/si";
import logobulking from "../Assets/partners/bulking.png";
import logoworld from "../Assets/partners/logowg.png";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer" data-animate="fade-right" data-delay="200">
      <div className="footer-container">

        {/* Topo: 3 colunas */}
        <div className="footer-top">

          <div className="footer-brand">
            <h3 className="footer-brand-logo">WOLF GANG</h3>
            <p className="footer-brand-tagline">#TeamSaboia</p>
            <p className="footer-brand-description">
              Transformação física através de metodologia científica e acompanhamento personalizado.
            </p>
          </div>

          <div className="footer-contact">
            <h4 className="footer-heading">Contato</h4>
            <div className="footer-contact-item">
              <FiPhone />
              <span>+55 (61) 99590-9917</span>
            </div>
            <div className="footer-contact-item">
              <FiMapPin />
              <span>Brasília, Brasil</span>
            </div>
          </div>

          <div className="footer-social">
            <h4 className="footer-heading">Siga nas redes</h4>
            <div className="footer-social-links">
              <a
                href="https://instagram.com/luissaboia.ofc"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-social-link"
              >
                <FiInstagram />
                <span>Instagram</span>
              </a>
              <a
                href="https://wa.me/5561995909917"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-social-link"
              >
                <SiWhatsapp />
                <span>WhatsApp</span>
              </a>
            </div>
          </div>

        </div>

        {/* Parceiros */}
        <div className="footer-sponsors">
          <h4 className="footer-heading footer-heading--center">Parceiros oficiais</h4>
          <div className="footer-sponsors-grid">

            <div className="footer-sponsor">
              <strong className="footer-sponsor-name">Bulking · Roupas</strong>
              <img
                src={logobulking}
                alt="Bulking Suplementos"
                className="footer-sponsor-logo"
              />
              <p className="footer-sponsor-line">
                Use o cupom: <strong>SABOIA</strong>
              </p>
              <span className="footer-sponsor-note">
                Roupas de academia · Fashion Fitness
              </span>
            </div>

            <div className="footer-sponsor">
              <strong className="footer-sponsor-name">World Gym · Sobradinho</strong>
              <img
                src={logoworld}
                alt="World Gym"
                className="footer-sponsor-logo"
              />
              <p className="footer-sponsor-line">
                Junte-se ao time e <strong>ganhe desconto na matrícula</strong>
              </p>
              <span className="footer-sponsor-note">Serious about fitness</span>
            </div>

          </div>
        </div>

        {/* Base */}
        <div className="footer-bottom">
          <div className="footer-legal">
            <span className="footer-legal-text">
              © 2026. Team Saboia. Todos os direitos reservados.
            </span>
            <div className="footer-legal-links">
              <a href="#powered-by">Powered by</a>
              <a href="#liberstack">liberstack</a>
            </div>
          </div>
        </div>

      </div>
    </footer>
  );
};

export default Footer;